import React from "react"
import { useTranslation } from "react-i18next"

import MultiTagRender from "../MultiTagRender"

const IrisCodeTroubleshootPanel = ({ data, contents, links }) => {
    const { t } = useTranslation()

    let contentData
    if(data?.data){
        contentData = data?.data
    }else{
        contentData = data
    }
    return (
        <>
            { contentData?.irisHelpTextTitle && (<div className="w-[100%]">
                <h1 className={ "font-bold text-secondary-50" }>
                    { contentData?.irisHelpTextTitle }
                </h1>
            </div>) }

            <MultiTagRender contents={ contents } links={links}/>
            { contentData?.accessoryTextlink && (
                <div className="w-[100%]">
                    <MultiTagRender contents={ contentData?.accessoryTextlink?.accessoryDynamicLink?.json?.content } />
                </div>
            ) }
            { contentData?.useInstructionTextlink && (
                <div className="w-[100%]">
                    { contentData?.useInstructionTextlink?.useInstructionTextTitle } 
                    &nbsp;&nbsp;
                    <a target="_blank" href={ contentData?.useInstructionTextlink?.useInstructionLink } className="text-primary-100 text-sm font-lighter underline" rel="noreferrer">{ t("common.link") }</a>
                </div>
            ) }
        </>
    )
}

export default React.memo(IrisCodeTroubleshootPanel)
